import React from "react";
import SendWhatsAppCampaign from "./SendWhatsAppCampaign";
import Sidebar from "../../Components/Sidebar";
import Header from "../../Components/Header";
import CustomTabsV2 from "../../Components/CustomTabs";
import SendAudioCampaign from "./SendAudioCampaign";
import SendTextCampaign from "./SendTextCampaign";

const SendCampaign = () => {
  // Tab configuration
  const tabs = [
    {
      label: "Voice",
      to: "voice",
      content: <SendAudioCampaign />,
    },
    {
      label: "Whatsapp",
      to: "whatsapp",
      content: <SendWhatsAppCampaign />,
    },
    {
      label: "SMS",
      to: "text",
      content: <SendTextCampaign />,
    },
  ];

  return (
    <>
      <div id="main-wrapper">
        <Header />
        <Sidebar />
        <div className="content-body" style={{ height: "100vh", overflowX: "hidden" }}>
          <div className="page-titles">
            <ol className="breadcrumb">
              <li>
                <h5 className="bc-title">Start Campaign</h5>
              </li>
              <li className="breadcrumb-item">
                <a href="javascript:void(0)">Home</a>
              </li>
              <li className="breadcrumb-item active">
                <a href="javascript:void(0)">Start Campaign</a>
              </li>
            </ol>
          </div>

          <div className="col-12 bst-seller pt-3" style={{ 
            padding: window.innerWidth <= 576 ? "10px" : "30px",
            maxWidth: "100%",
            overflowX: "hidden",
          }}>
            <div className="card" style={{ overflowX: "hidden" }}>
              <CustomTabsV2 tabs={tabs} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SendCampaign;
